<template>
  <div>
    <b-row>
      <b-col sm="2">
        <Callout variant="dark">
          <small class="text-muted">Número de Proceso</small>
          <br>
          <strong class="h4"># {{processNumber}}</strong>
        </Callout>
      </b-col>
      <b-col sm="2">
        <Callout :variant="calloutvariant">
          <small class="text-muted">Kilos a proceso</small>
          <br>
          <strong class="h4">{{sumMarkedKilograms.format('0,0.00')}} Kg</strong>
        </Callout>
      </b-col>
      <b-col sm="2">
        <Callout :variant="calloutvariant">
          <small class="text-muted">Kilos volteados</small>
          <br>
          <strong class="h4">{{sumNetKilograms.format('0,0.00')}} Kg</strong>
        </Callout>
      </b-col>
      <b-col sm="2">
        <Callout :variant="calloutvariant">
          <small class="text-muted">Cuadratura</small>
          <br>
          <strong class="h4">{{kilogramDiference.format('0,0.00')}} Kg</strong>
        </Callout>
      </b-col>
      <b-col sm="2">
        <Callout variant="secondary">
          <small class="text-muted">Porcentaje de exportación</small>
          <br>
          <strong class="h4">{{exportPercentage}}</strong>
        </Callout>
      </b-col>
      <b-col sm="2">
        <Callout variant="secondary">
          <small class="text-muted">Porcentaje de merma</small>
          <br>
          <strong class="h4">{{wastePercentage}}</strong>
        </Callout>
      </b-col>
    </b-row>
    <hr class="mt-0">
  </div>

</template>

<script>
  import { Callout } from '@coreui/vue'
  import numeral from 'numeral';
  numeral.locale('es');

    export default {
      name: "InformacionProceso",
      components:{
        Callout
      },
      props: [
        'sumMarkedKilograms',
        'sumNetKilograms',
        'processNumber',
        'kilogramDiference',
        'kilogramExportacion',
        'kilogramMerma',
        'wastePercentage',
        'exportPercentage',
      ],
      computed:{
        calloutvariant(){
          return this.kilogramDiference.value() === 0 ? 'success' : 'danger';
        },
        getkilogramExportacion(){

          let  kilogramExportacionAux = (parseFloat(this.kilogramExportacion) / parseFloat(this.sumMarkedKilograms.value())) * 100;
          return numeral(kilogramExportacionAux).format('0,0.00');
        },
        getkilogramMerma(){

          
          let  kilogramMermaAux = (parseFloat(this.kilogramMerma) / parseFloat(this.sumMarkedKilograms.value())) * 100;

  
          return numeral(kilogramMermaAux).format('0,0.00');
        }
      }
    }
</script>

<style scoped>

</style>
